module.exports = __webpack_public_path__ + "static/insert_legend_4-e356058f9808ca0a4fbc8f90ec60974d.png";